import axios from 'axios'
// import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn"
const url = {
  getVideoType: `${root}/Base/getVideoType`, // 视听资源->视频分类获取
  getVideo: `${root}/Base/getVideo`, // 视听资源->视频资源获取
  getLikeVideo: `${root}/Audio/getLikeVideo`, // 视听->获取学生喜欢的视频的列表
  getOneVideo: `${root}/Audio/getOneVideo`, // 视听->获取单个视频的信息
  like: `${root}/Audio/like`,
  changeLike: `${root}/Audio/changeLike`,
}
const videoStore = {
  getVideoType(params :any) {
    return axios.get(url.getVideoType, { params })
  },
  getVideo(params :any) {
    return axios.get(url.getVideo, { params })
  },
  getLikeVideo(params :any) {
    return axios.get(url.getLikeVideo, { params })
  },
  getOneVideo(params :any) {
    return axios.get(url.getOneVideo, { params })
  },
  like(params :any) {
    return axios.get(url.like, { params })
  },
  changeLike(params :any) {
    return axios.get(url.changeLike, { params })
  },
}

export default videoStore;